import { call, takeLatest } from 'redux-saga/effects';
import { invalidatesRequest, requestTypes } from '../requestState';

// A reset must cancel a pending worker even when no replacement request follows.
export default function* watchRequest(kind, worker) {
  const type = requestTypes[kind];
  yield takeLatest(
    (action) => action.type === type || invalidatesRequest(kind, action),
    function* handleRequest(action) {
      if (action.type === type) {
        yield call(worker, action);
      }
    },
  );
}
